<template>
  <b-card body-class="pa-0">
    <b-tabs active-tab-class="pa-0" card>
      <b-tab active title="User connected proposals">
        <proposals-list-readonly :excluded-id="currentProposalObjectId"
                                 :previous-proposals-pointer="previousProposalsPointer"
                                 :userIds="userId"/>
      </b-tab>

      <b-tab title="Reviews">
        <base-reviews-details v-if="reviewersLoadingComplete"
                              :constructed-reviews="constructReviews(this.proposal)"
                              :is-rapid-access="isRapidAccess"/>
      </b-tab>

      <b-tab title="Technical evaluation">
        <final-grade-details-technical-evaluation :proposal-technical-evaluation="proposal.technical_evaluation"/>
      </b-tab>

      <b-tab title="History">
        <final-grade-details-proposal-history :proposal="proposal"/>
      </b-tab>

      <b-tab title="User connected publications">
        <publications-list-readonly :user-id="userId"/>
      </b-tab>

      <b-tab title="Team connected proposals">
        <proposals-list-readonly :excluded-id="currentProposalObjectId"
                                 :previous-proposals-pointer="previousProposalsPointer"
                                 :userIds="teamIds"/>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
  import ProposalsListReadonly from '@/components/proposal/proposals/ProposalsListReadonly';
  import PublicationsListReadonly from '@/components/proposal/proposals/PublicationsListReadonly';
  import { reviewsDetails } from '@/mixins/reviewsDetails';
  import { infrastructureMixin } from '@/mixins/infrastructure';
  import BaseReviewsDetails from '@/components/base-components/BaseReviewsDetails';
  import FinalGradeDetailsProposalHistory from '@/components/evaluation/final-grade/FinalGradeDetailsProposalHistory';
  import FinalGradeDetailsTechnicalEvaluation
    from '@/components/evaluation/final-grade/FinalGradeDetailsTechnicalEvaluation';

  export default {
    name: 'ProposalShowDetailsRow',
    components: {
      ProposalsListReadonly,
      PublicationsListReadonly,
      BaseReviewsDetails,
      FinalGradeDetailsTechnicalEvaluation,
      FinalGradeDetailsProposalHistory,
    },
    props: {
      proposal: {
        type: Object,
        required: true,
      },
      isRapidAccess: {
        type: Boolean,
        default: false,
      },
    },
    mixins: [reviewsDetails, infrastructureMixin],
    computed: {
      userId() {
        return this.proposal.team.team_members.find((member) => member.roles.MAIN_AUTHOR).user_id;
      },
      teamIds() {
        return this.proposal.team.team_members.map((member) => member.user_id);
      },
      currentProposalObjectId() {
        return this.getId(this.proposal);
      },
      previousProposalsPointer() {
        return this.proposal.general.previous_proposals;
      },
    },
  };
</script>

<style scoped>
  .card {
    margin: 0 !important;
  }
</style>
